import { getIpAddressEndpoint,getHMAC,postHMAC } from "./../../services/RestAPIWrapper";
import {
    SIGNER_DETAILANDSETTINGS_REQUEST,
    SIGNER_DETAILANDSETTINGS_SUCCESS,
    SIGNER_DETAILANDSETTINGS_FAIL,
    CREATE_SIGNER_FAIL,
    CREATE_SIGNER_SUCCESS,
    CREATE_SIGNER_REQUEST,
    IPADDRESS_DETAIL_REQUEST,
    IPADDRESS_DETAIL_SUCCESS,
    IPADDRESS_DETAIL_FAIL,
    CALLBACK_REQUEST,
    CALLBACK_SUCCESS,
    CALLBACK_FAIL,
    EMAILAUTHENTICATION_REQUEST,
    EMAILAUTHENTICATION_SUCCESS,
    EMAILAUTHENTICATION_FAIL,
    DOCUMENT_DETAIL_REQUEST,
    DOCUMENT_DETAIL_SUCCESS,
    DOCUMENT_DETAIL_FAIL,
    SIGNDOCUMENT_SUCCESS,
    SIGNDOCUMENT_REQUEST,
    SIGNDOCUMENT_FAIL,
    ISERRORSERVER,
    RESET
} from '../constants/App';

import { endPoints } from '../../config/ApiConfig';




function signerDetailAndSettingsRequest() {
    return {
        type: SIGNER_DETAILANDSETTINGS_REQUEST
    }
}

function signerDetailAndSettingsReceiveData(json) {
    return {
        type: SIGNER_DETAILANDSETTINGS_SUCCESS,
        data: json
    }
}

export function getSignerDetailsAndSettings(code) {
    return dispatch => {
        dispatch(signerDetailAndSettingsRequest());
        const url = `${endPoints.getSignerDetailsAndSettings.endPoint}?encodedId=${encodeURIComponent(code)}`;
        return getHMAC(url, "", json => {
            if (json.Success === 'false') {
                return dispatch({ type: SIGNER_DETAILANDSETTINGS_FAIL, data: json });
            } else {
                return (dispatch(signerDetailAndSettingsReceiveData(json)));
            }
        }, err => {
            console.log(err);
            return dispatch(errorServer(err));
        });
    };
}

// create Signer
function createSignerRequest() {
    return {
        type: CREATE_SIGNER_REQUEST
    }
}

function createSignerSaveReceiveData(json, id = '') {
    return {
        type: CREATE_SIGNER_SUCCESS,
        data: json,
        sign_id: id,
    }
}

export function createSigner(signer) {

    return dispatch => {
        dispatch(createSignerRequest());

        return postHMAC(endPoints.createSigningOrder.endPoint, signer, json => {
            if (json.Success === 'false') {
                return dispatch({ type: CREATE_SIGNER_FAIL, data: json });
            } else {
                const query = new URLSearchParams(json);
                const signingOrderId = query.get('sign_id');
                return (dispatch(createSignerSaveReceiveData(json, signingOrderId)));
            }
        }, err => {
            console.log(err);
            return dispatch(errorServer(err));
        })
    };
}

function getIpAddressRequest() {
    return {
        type: IPADDRESS_DETAIL_REQUEST
    }
}
function setIpAddress(json) {
    return {
        type: IPADDRESS_DETAIL_SUCCESS,
        data: json
    }
}

export function getIpAddress() {
    return dispatch => {
        dispatch(getIpAddressRequest());

        return new Promise((resolve, reject) => {
            getIpAddressEndpoint(
                endPoints.getIpAddress.endPoint,
                "",
                json => {
                    if (json.Success === 'false') {
                        dispatch({ type: IPADDRESS_DETAIL_FAIL, data: json });
                        reject(json);
                    } else {
                        dispatch(setIpAddress(json));
                        resolve(json);
                    }
                },
                err => {
                    console.log(err);
                    dispatch(errorServer(err));
                    reject(err);
                }
            );
        });
    };
}
function callbackRequest() {
    return {
        type: CALLBACK_REQUEST
    }
}

function callbackData(json) {
    return {
        type: CALLBACK_SUCCESS,
        data: json
    }
}

export function callback(authorizationResponse) {
    return dispatch => {
        dispatch(callbackRequest());
        return postHMAC(endPoints.callback.endPoint, authorizationResponse, json => {
            if (json.Success === 'false') {
                return dispatch({ type: CALLBACK_FAIL, data: json });
            } else {
                return (dispatch(callbackData(json)));
            }
        }, err => {
            console.log(err);
            return dispatch(errorServer(err));
        });
    };
}

// Get documents Details
function documentDetailRequest() {
    return {
        type: DOCUMENT_DETAIL_REQUEST
    }
}

function documentDetailReceiveData(json) {
    return {
        type: DOCUMENT_DETAIL_SUCCESS,
        data: json
    }
}

export function getDocuments(code) {
    return dispatch => {
        dispatch(documentDetailRequest());
        const url = `${endPoints.getDocuments.endPoint}?encodedId=${encodeURIComponent(code)}`;
        return getHMAC(url, '', json => {
            if (json.Success === 'false') {
                return dispatch({ type: DOCUMENT_DETAIL_FAIL, data: json });
            } else {
                return (dispatch(documentDetailReceiveData(json)));
            }
        }, err => {
            console.log(err);
            return dispatch(errorServer(err));
        });
    };
}


function authenticateSignerRequest() {
    return {
        type: EMAILAUTHENTICATION_REQUEST
    }
}

function authenticateSignerReceive(json) {
    return {
        type: EMAILAUTHENTICATION_SUCCESS,
        data: json
    }
}

export function authenticateSigner(code, emailAddress) {

    return dispatch => {
        dispatch(authenticateSignerRequest());
        const url = `${endPoints.authenticateSigner.endPoint}?encodedId=${encodeURIComponent(code)}&emailAddress=${encodeURIComponent(emailAddress)}`;
        return getHMAC(url, '', json => {
            if (json.Success === 'false') {
                return dispatch({ type: EMAILAUTHENTICATION_FAIL, data: json });
            } else {
                return (dispatch(authenticateSignerReceive(json)));
            }
        }, err => {
            console.log(err);
            return dispatch(errorServer(err));
        })
    };
}

function signDocumentRequest() {
    return {
        type: SIGNDOCUMENT_REQUEST
    }
}

function signDocumentReceive(json) {
    return {
        type: SIGNDOCUMENT_SUCCESS,
        data: json
    }
}

export function signDocument(code) {

    return dispatch => {
        dispatch(signDocumentRequest());
        const url = `${endPoints.signDocument.endPoint}?encodedId=${encodeURIComponent(code)}`;
        return getHMAC(url, '', json => {
            if (json.Success === 'false') {
                return dispatch({ type: SIGNDOCUMENT_FAIL, data: json });
            } else {
                return (dispatch(signDocumentReceive(json)));
            }
        }, err => {
            console.log(err);
            return dispatch(errorServer(err));
        })
    };
}

// Reset state 
function resetRequest() {
    return {
        type: RESET
    }
}

export function reset() {

    return dispatch => {
        dispatch(resetRequest());
    };
}


// Error 
export function errorServer(error) {
    return {
        type: ISERRORSERVER,
        data: error
    }
}
